var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_2451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8365 32 32 24.8365 32 16C32 7.16344 24.8365 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8365 7.16344 32 16 32Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3629 19.9173V22.3098H10.6812C10.8143 20.7347 11.3131 19.627 13.0365 18.0685L20.3629 11.6965V17.2885H23V7H8.00294V12.1285H10.6393V9.68875H18.6064L11.316 16.0323L11.2984 16.0488C8.24274 18.8072 8 21.0333 8 23.656V25H22.9992V19.9181H20.3622L20.3629 19.9173Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_2451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzeta);
export default __webpack_public_path__ + "static/media/azeta.1730df993119b1c0cad582ac0e875954.svg";
export { ForwardRef as ReactComponent };